
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BusinessSetup from "../pages/business-setup/page";
import TaxAgency from "../pages/tax-agency/page";
import QualificationPermit from "../pages/qualification-permit/page";
import PolicySubsidy from "../pages/policy-subsidy/page";
import RegisteredAddress from "../pages/registered-address/page";
import GovernmentPlatform from "../pages/government-platform/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/business-setup",
    element: <BusinessSetup />,
  },
  {
    path: "/tax-agency", 
    element: <TaxAgency />,
  },
  {
    path: "/qualification-permit",
    element: <QualificationPermit />,
  },
  {
    path: "/policy-subsidy",
    element: <PolicySubsidy />,
  },
  {
    path: "/registered-address",
    element: <RegisteredAddress />,
  },
  {
    path: "/government-platform",
    element: <GovernmentPlatform />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
